import { lazy } from "react";

const Expedicao = lazy(() => import("./Expedicao"));
const Despacho = lazy(() => import("./Despacho"));
const Conferencia = lazy(() => import("./Conferencia"));

const expedicaoRoutes = [
  {
    path: "/expedicao/expedicao",
    element: <Expedicao />,
  },
  {
    path: "/expedicao/despacho",
    element: <Despacho />,
  },
  {
    path: "/expedicao/conferencia",
    element: <Conferencia />,
  },
];

export default expedicaoRoutes;
